import { DEVELOPER_AUTH_DOMAIN, PAMPAS_CAT, USER_AUTH_DOMAIN } from "./config";

const USER_AUTH_CONFIG = {
  Auth: {
    Cognito: {
      userPoolId: "us-east-1_keK5Iwm9p",
      userPoolClientId: "5k0csdl8p59k2lns3qidlj62tb",
      loginWith: {
        oauth: {
          domain: USER_AUTH_DOMAIN,
          scopes: ["openid", "email"],
          redirectSignIn: [`${PAMPAS_CAT}/user-login-callback`],
          redirectSignOut: [`${PAMPAS_CAT}/user-logout`],
          responseType: "code",
        },
      },
    },
  },
};

const DEVELOPER_AUTH_CONFIG = {
  Auth: {
    Cognito: {
      userPoolId: "us-east-1_Ximo8YJvC",
      userPoolClientId: "54n9bvfkb8udvkmdccsbk9a2n6",
      loginWith: {
        oauth: {
          domain: DEVELOPER_AUTH_DOMAIN,
          scopes: ["openid", "email"],
          redirectSignIn: [`${PAMPAS_CAT}/developer/login`],
          redirectSignOut: [`${PAMPAS_CAT}/developer/login`],
          responseType: "code",
        },
      },
    },
  },
};

export { DEVELOPER_AUTH_CONFIG, USER_AUTH_CONFIG };
